import { Guid, Nillable } from '@web/utils';
import { PublicAvailability } from '../enums';
import { SalesType } from '../../shared/enums';

export class PublicSales {
  public constructor(
    private readonly data: {
      id: Guid;
      type: SalesType;
      availability: PublicAvailability;
      subProductId?: Nillable<Guid>;
      maxQuantityPerOrder?: Nillable<number>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get type(): SalesType {
    return this.data.type;
  }

  public get availability(): PublicAvailability {
    return this.data.availability;
  }

  public get subProductId(): Nillable<Guid> {
    return this.data.subProductId;
  }

  public get maxQuantityPerOrder(): Nillable<number> {
    return this.data.maxQuantityPerOrder;
  }

  public isAvailable(): boolean {
    return this.availability === PublicAvailability.Available;
  }
}
